import { Alert } from '@mui/material';
import { useTranslate } from 'react-admin';
import { useCanAccess } from '@react-admin/ra-rbac';
import { Navigate, useSearchParams } from 'react-router-dom';
import { getSchoolMergePath, MERGE_RESOURCES, MergeView } from './mergeNavigation';

const LegacyMergeRedirect = ({ view }: { view: MergeView }) => {
    const [params] = useSearchParams();
    const translate = useTranslate();
    const { canAccess, isPending } = useCanAccess({
        action: 'read',
        resource: 'merge',
    });
    const resource = MERGE_RESOURCES.find(
        value => value === params.get('resource')
    );
    const school = params.get('school') || '';
    if (isPending) return null;
    if (!canAccess) return <Navigate replace to="/" />;
    if (
        !resource ||
        !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
            school
        )
    )
        return (
            <Alert severity="error">
                {translate('merge.bulk.invalid_context')}
            </Alert>
        );
    return <Navigate replace to={getSchoolMergePath(school, resource, view)} />;
};

export default LegacyMergeRedirect;
